import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    name: {
      inputType: 'text',
      title: 'Name',
      required: true,
      tooltip: 'Who the key is for, e.g. "NetSuite accounting integration".',
    },
    description: {
      inputType: 'textarea',
      title: 'Description',
      required: false,
      tooltip: 'Optional: what it is used for, who owns it, where it is configured.',
    },
    expiresAt: {
      inputType: 'text',
      type: 'date',
      title: 'Expires',
      required: false,
      tooltip: 'Leave blank for a key that never expires.',
    },
  }
}
